export default "__VITE_ASSET__CXE4n4dH__"